import styled, { css, keyframes } from 'styled-components';

import { mediaQuery } from '../../styles/mixin';
import { Tag } from '../Tag';

export const StyledTable = styled.table`
    --table-field-padding: 0.5rem;
    --table-side-offset: 1rem;

    ${mediaQuery(
        2,
        css`
            --table-side-offset: 2rem;
        `
    )}
    margin-top: 1rem;
    width: 100%;
    font-size: ${({ theme }) => theme.fontSizes[4]};
    line-height: 1.4285714286;
    display: block;
`;

// Table Head

export const TableHead = styled.thead`
    background: transparent;
    display: flex;
    flex-flow: column-reverse;
`;

interface ITableHeadCellProps {
    rightAligned?: boolean;
}

export const TableHeadCell = styled.th<ITableHeadCellProps>`
    color: ${({ theme }) => theme.colors.fontPrimary};
    justify-content: ${({ rightAligned }) =>
        rightAligned ? 'flex-end' : 'flex-start'};
    display: flex;
    flex-direction: row;
    align-items: flex-end;
    padding-left: 0;

    button {
        padding-left: 0;
    }
`;

interface ITableHeadRowProps {
    isSubHead?: boolean;
}

export const TableHeadRow = styled.tr<ITableHeadRowProps>`
    padding: 0.75rem var(--table-side-offset);
    border-bottom: 1px solid ${({ theme }) => theme.colors.mediumShadow};

    &:nth-of-type(odd) {
        padding: 0.625rem var(--table-side-offset);
        background: ${({ theme }) => theme.colors.lightShadow};
    }
`;

export const TableHeadTitle = styled.span`
    font-weight: 600;
`;

interface ITableHeadDataProps {
    selected?: boolean;
    clickable?: boolean;
    compact?: boolean;
}

export const TableHeadData = styled.div<ITableHeadDataProps>`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border: none;
    margin: 0;
    padding: ${({ compact }) => (compact ? '0rem' : '0rem')};
    border-radius: 0.5rem;
    cursor: ${({ clickable }) => (clickable ? 'pointer' : 'default')};
    background: ${({ theme, selected }) =>
        selected ? theme.colors.lightShadow : 'transparent'};
`;

// Table Body
interface IScrollableContainer {
    maxHeight: number;
}

export const TableBody = styled.tbody<IScrollableContainer>`
    height: ${({ maxHeight }) => maxHeight}px;
    width: 100%;
    overflow: scroll;
    display: inline-block;

    ::-webkit-scrollbar {
        display: none;
    }
`;

interface ITableBodyCellProps {
    clickable?: boolean;
}

export const TableBodyCell = styled.td<ITableBodyCellProps>`
    color: ${({ theme }) => theme.colors.fontPrimary};
    padding: 1rem 0rem;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    display: flex;
    align-items: center;
    cursor: ${({ clickable }) => (clickable ? 'pointer' : 'default')};
`;

export const TableBodyRow = styled.tr`
    padding-left: var(--table-side-offset);
    padding-right: var(--table-side-offset);

    &:not(:first-of-type) {
        border-top: 1px solid ${({ theme }) => theme.colors.mediumShadow};
    }
`;

const TableLoadingContentAnimation = keyframes`
    0% {
        background-position: 0 0;
    }

    50% {
        background-position: 50% 0;
    }

    100% {
        background-position: 100% 0;
    }
`;

export const TableLoadingContent = styled.div`
    height: 1rem;
    width: 70%;
    display: flex;
    background: linear-gradient(90deg, #f7f8fa, #ebecf3, #f7f8fa, #ebecf3);
    background-size: 400%;
    animation: ${TableLoadingContentAnimation} 2s ease infinite forwards;
`;

export const TableLoadingRow = styled(TableBodyRow)`
    width: 100%;
    display: flex;
    flex-direction: row;
`;

export const TableEmptyState = styled.div`
    height: 50vh;
    display: flex;
    align-items: center;
    justify-content: center;
`;

const Cell = styled.span``;

interface IWorthCellProps {
    alignRight?: boolean;
}

export const WorthCell = styled(Cell)<IWorthCellProps>`
    color: ${({ theme }) => theme.colors.logoPrimary};
    width: 100%;
    font-weight: 600;
    text-align: ${({ alignRight }) => (alignRight ? 'right' : 'left')};
`;

interface IEllipsisCellProps {
    highlighted?: boolean;
}

export const EllipsisCell = styled(Cell)<IEllipsisCellProps>`
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow-x: hidden;
    font-weight: ${({ highlighted }) => (highlighted ? '600' : '400')};
`;

export const NewTag = styled(Tag)`
    display: none;
    ${mediaQuery(
        2,
        css`
            display: flex;
            justify-content: center;
            align-items: center;
            grid-area: badge;
            padding: 0.25rem;
        `
    )}
`;

export const StyledNewMobileTag = styled.div`
    width: 0.5rem;
    height: 0.5rem;
    background: ${({ theme }) => theme.colors.logoPrimary};
    border-radius: 50%;
    justify-self: flex-end;
    align-self: center;
    ${mediaQuery(
        2,
        css`
            display: none;
        `
    )}
`;
